import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompanyInfoForm from '../../../components/forms/CompanyInfoForm';
import { CompanyInfoClient, CompanyInfoDTO } from '../../../services/apiClient';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from "../../../services/axiosInstance";

const CompanyInfoEdit: React.FC = () => {
  const [companyInfo, setCompanyInfo] = useState<CompanyInfoDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const apiClient = new CompanyInfoClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Company Info', href: '/admin/companyinfo' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const response = await apiClient.getCompanyInfoById(id!);
        setCompanyInfo(response.data || null);
      } catch (error) {
        console.error('Error fetching company info:', error);
      }
    };

    fetchCompanyInfo();
  }, [id]);

  const handleSubmit = async (data: any) => {
    setIsSubmitting(true);
    try {
      await apiClient.updateCompanyInfo(id!, data);
      navigate('/admin/companyinfo');
    } catch (error) {
      console.error('Error updating company info:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/companyinfo"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card title="Edit Company Info">
        {companyInfo ? (
          <CompanyInfoForm
            initialValues={companyInfo}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/companyinfo')}
          />
        ) : (
          <p>Loading...</p>
        )}
      </Card>
    </AdminLayout>
  );
};

export default CompanyInfoEdit;
